module.exports = __webpack_public_path__ + "img/placeholder.3c0a422.jpg";